module.exports = __webpack_public_path__ + "static/img/rbg.3230f7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/rbg.png
// module id = 0Ckk
// module chunks = 1